import script from "./TechnicalFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicalFlow.vue?vue&type=script&setup=true&lang=js"

import "./TechnicalFlow.vue?vue&type=style&index=0&id=082cd4c5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-082cd4c5"]])

export default __exports__